import * as React from 'react';
import { EntityConfig, entityTaxonomyFormFields } from '@shapeable/core';
import { CourseLevel as MyType } from '@shapeable/ibj-types';

export const CourseLevel: EntityConfig<MyType> = {
  name: 'CourseLevel',
  slug: 'course-level',
  label: 'Course Level',
  type: 'taxonomy',
  form: {
    fieldSets: [
      { name: 'overview' },
      { name: 'zh', label: '中文' },
      { name: 'vi', label: 'Tiếng Việt' },
    ],
    fields: {
      ...entityTaxonomyFormFields,
      description: { type: 'description' },
      level: { type: 'int', label: 'Level', maxWidth: '150px' },

      name_zh: { type: 'text', fieldSet: 'zh', label: 'Name', badge: "中文" },
      name_vi: { type: 'text', fieldSet: 'vi', label: 'Name', badge: "Tiếng Việt" },
    }
  },
  select: {
    maxWidth: '400px',
  },
  autoRoutes: ['list', 'create', 'update'],
};